import _ from 'lodash';
import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import autobind from 'autobind-decorator';

import config from 'client/shared/config';
import { DeleteButton } from 'client/shared/components';

@inject('artistStore')
@observer
class PhotoList extends Component {
	render () {
		const { artistStore, userID, rowUserID } = this.props;
		const artist = artistStore.getArtistByUserID(_.isEmpty(rowUserID) ? userID : rowUserID._id);
		const { photos } = artist;

		if (_.isEmpty(photos)) {

			return (<h5>No Photos</h5>);
		}

		return (
			<div className="grid-x">
				{
					photos.map(
						(photo, index) => (
							<div key={ index } className="cell shrink padding-top-1 padding-right-1">
								<img src={ `/artist${config.paths.imgBasePath}/${photo}` }
									 className="image medium" />

								<DeleteButton
 									warningText="Really delete this photo?"
 									onConfirmClick={ this.onConfirmClick }>
 										<button className="button secondary clear margin-bottom-0 padding-0">
 											<span className="fi-trash icon padding-0"></span> delete
 										</button>
 								</DeleteButton>
							</div>
						)
					)
				}
			</div>
		);
	}

	@autobind
	onConfirmClick () {
		const { artistStore, photo } = this.props;
		artistStore.removeArtistPhoto(photo);
	}
}

export default PhotoList;
